export class VoluntaryRequestReport {
    dateFrom:string=''
    dateTo:string=''
    
}
